// Página «Sala» del menú superior del HCE (Sala CRM↔HCE, rebanada 5; PLAN 4.11): los pacientes del día del médico, por hora de llegada. El mismo
// componente se incrusta en el Dashboard, debajo del calendario (`SalaPanel`): no hay dos versiones.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { AvisosCierreSala } from '@/dashboard/AvisosCierreSala';
import { SalaPanel } from '@/dashboard/SalaPanel';
import { TopNav } from '@/dashboard/TopNav';

export function SalaPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-6xl space-y-4 py-4">
      <TopNav activo="sala" />
      <p className="text-sm text-hce-muted">{t('sala.subtitulo')}</p>
      <AvisosCierreSala />
      <SalaPanel variante="pagina" />
    </div>
  );
}
